/**
 * Appends skipIntro=1 so the target site skips the home intro (language switch = not first open).
 */
export function withSkipIntroParam(url) {
  if (!url || typeof url !== 'string') return url
  try {
    const u = new URL(url)
    u.searchParams.set('skipIntro', '1')
    return u.href
  } catch {
    return url.includes('?') ? `${url}&skipIntro=1` : `${url}?skipIntro=1`
  }
}
